export default __webpack_public_path__ + "static/media/redux.c7528bef.png";